import { schemas } from "@card-data/generated/api.client";

import { REFERRALS } from "../referral-links";
import { CreditCardInput } from "../types";

export const DISCOVER_CARDS: Array<CreditCardInput> = [
  {
    cardId: "dae75a5609dea8f39f750f4b225d2c5c",
    name: "Discover It",
    issuer: schemas.IssuersEnum.enum.DISCOVER,
    network: schemas.NetworksEnum.enum.DISCOVER,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.discover.com/credit-cards/",
    imageUrl: "/images/discover/it.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 300 }],
        spend: 500,
        days: 90,
        credits: [],
        details:
          "Includes the $100 referral bonus after any payment within 8 weeks; card also doubles all cash back earned in the first year.",
        referralUrl: REFERRALS.DISCOVER,
      },
      {
        amount: [{ amount: 200 }],
        spend: 500,
        days: 90,
        credits: [],
        details:
          "Direct offer. Card also doubles all cash back earned in the first year.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200 }],
        spend: 500,
        days: 90,
        credits: [],
        details:
          "Direct welcome offer, no referral required. Card also doubles all cash back earned in the first year.",
        referralUrl: REFERRALS.DISCOVER,
        expiration: "2026-08-14",
      },
      {
        amount: [{ amount: 100 }],
        spend: 0.01,
        days: 90,
        credits: [],
        details: "Referral only. You get $100, referrer gets $100.",
      },
      {
        amount: [{ amount: 100 }],
        spend: 0.01,
        days: 90,
        credits: [],
        details: "Referral only.",
      },
    ],
  },
];
